export default __webpack_public_path__ + "static/media/intro-apis.0f8127af.png";